import React from 'react';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface WarningModalProps {
  title: string;
  body: string;
}

const WarningModal: React.FC<WarningModalProps> = ({ title, body }) => {
  return (
    <>
      <div className="display-flex">
        <ExclamationCircleOutlined rev={undefined} className="WarningModalIcon" />
        <p className="para-styles">{title}</p>
      </div>
      <div className="error-btn">{body}</div>
    </>
  );
};

export default WarningModal;
